"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.polygonInstructions = exports.threeDimInstructions = exports.imageInstructions = exports.videoInstructionsMisfit = exports.videoInstructionsFit = void 0;
const plugin_html_multi_response_1 = __importDefault(require("@jspsych-contrib/plugin-html-multi-response"));
const __1 = require("../../..");
const helpers_1 = require("../../shared/helpers");
const taskSetup_1 = require("../../taskSetup");
const taskStore_1 = require("../../../taskStore");
const replayButtonHtmlId = 'replay-btn-revisited';
const audioConfig = {
    restrictRepetition: {
        enabled: true,
        maxRepetitions: 2,
    },
    onEnded: helpers_1.enableOkButton,
};
// Switch to HTMLMultiResponse when we have video with audio
exports.videoInstructionsFit = {
    type: plugin_html_multi_response_1.default,
    data: () => {
        return {
            // save_trial: true,
            assessment_stage: 'instructions',
        };
    },
    stimulus: () => {
        const videoSrc = __1.mediaAssets.video.mentalRotationExampleFit;
        return `
      <div class="lev-stimulus-container">
        ${(0, helpers_1.getParticipantUtilityButtonsHtml)(replayButtonHtmlId)}
        <video class="instruction-video" autoplay>
          <source src=${videoSrc} type="video/mp4"/>
          Video not loading: ${videoSrc}. Please continue the task.
        </video>
      </div>
    `;
    },
    prompt_above_buttons: true,
    button_choices: ['Continue'],
    button_html: () => {
        const t = (0, taskStore_1.taskStore)().translations;
        return `<button class="primary" disabled>${t.continueButtonText}</button>`;
    },
    keyboard_choices: 'NO_KEYS',
    on_load: () => {
        // const wrapper = document.getElementById('jspsych-audio-multi-response-prompt');
        // wrapper.style.display = 'flex';
        // wrapper.style.justifyContent = 'center';
        helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio.mentalRotationTrainingInstruct3, audioConfig);
        const pageStateHandler = new helpers_1.PageStateHandler('mental-rotation-training-instruct3', true);
        (0, helpers_1.setupReplayAudio)(pageStateHandler);
        (0, helpers_1.addExperimenterButtons)();
        (0, helpers_1.setupFullscreenButton)();
    },
    on_finish: () => {
        helpers_1.PageAudioHandler.stopAndDisconnectNode();
        taskSetup_1.jsPsych.data.addDataToLastTrial({
            audioButtonPresses: helpers_1.PageAudioHandler.replayPresses,
        });
    },
};
exports.videoInstructionsMisfit = {
    type: plugin_html_multi_response_1.default,
    data: () => {
        return {
            assessment_stage: 'instructions',
        };
    },
    stimulus: () => {
        const videoSrc = __1.mediaAssets.video.mentalRotationExampleMisfit;
        return `
      <div class="lev-stimulus-container">
        ${(0, helpers_1.getParticipantUtilityButtonsHtml)(replayButtonHtmlId)}
        <video class="instruction-video" autoplay>
          <source src=${videoSrc} type="video/mp4"/>
          Video not loading: ${videoSrc}. Please continue the task.
        </video>
      </div>
    `;
    },
    prompt_above_buttons: true,
    button_choices: ['Continue'],
    button_html: () => {
        const t = (0, taskStore_1.taskStore)().translations;
        return `<button class="primary" id="ok-button" disabled>${t.continueButtonText}</button>`;
    },
    keyboard_choices: 'NO_KEYS',
    on_load: () => {
        helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio.mentalRotationTrainingInstruct2, audioConfig);
        const pageStateHandler = new helpers_1.PageStateHandler('mental-rotation-training-instruct2', true);
        (0, helpers_1.setupReplayAudio)(pageStateHandler);
        (0, helpers_1.addExperimenterButtons)();
        (0, helpers_1.setupFullscreenButton)();
    },
    on_finish: () => {
        helpers_1.PageAudioHandler.stopAndDisconnectNode();
        taskSetup_1.jsPsych.data.addDataToLastTrial({
            audioButtonPresses: helpers_1.PageAudioHandler.replayPresses,
        });
    },
};
exports.imageInstructions = {
    type: plugin_html_multi_response_1.default,
    data: () => {
        return {
            assessment_stage: 'instructions',
        };
    },
    stimulus: () => {
        const imageSrc = __1.mediaAssets.images.mentalRotationExample;
        return `
      <div class="lev-stimulus-container">
        ${(0, helpers_1.getParticipantUtilityButtonsHtml)(replayButtonHtmlId)}
        <img 
          src=${imageSrc} 
          class="instruction-video" 
          alt="Image not loading: ${imageSrc}. Please continue the task."
        />
      </div>
    `;
    },
    prompt_above_buttons: true,
    button_choices: ['Continue'],
    button_html: () => {
        const t = (0, taskStore_1.taskStore)().translations;
        return `<button class="primary" disabled>${t.continueButtonText}</button>`;
    },
    keyboard_choices: 'NO_KEYS',
    on_load: () => {
        helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio.mentalRotationInstruct1, audioConfig);
        const pageStateHandler = new helpers_1.PageStateHandler('mental-rotation-instruct1', true);
        (0, helpers_1.setupReplayAudio)(pageStateHandler);
        (0, helpers_1.addExperimenterButtons)();
        (0, helpers_1.setupFullscreenButton)();
    },
    on_finish: () => {
        helpers_1.PageAudioHandler.stopAndDisconnectNode();
        taskSetup_1.jsPsych.data.addDataToLastTrial({
            audioButtonPresses: helpers_1.PageAudioHandler.replayPresses,
        });
    },
};
exports.threeDimInstructions = {
    type: plugin_html_multi_response_1.default,
    data: () => {
        return {
            assessment_stage: 'instructions',
        };
    },
    stimulus: () => {
        const t = (0, taskStore_1.taskStore)().translations;
        const prompt = (0, taskStore_1.taskStore)().heavyInstructions ? t.mentalRotationInstruct3DDownex : t.mentalRotationInstruct3D;
        return `
      <div class="lev-stimulus-container">
        ${(0, helpers_1.getParticipantUtilityButtonsHtml)(replayButtonHtmlId)}
        <div class="lev-row-container instruction">
          <p>${prompt}</p>
        </div>
      </div>
    `;
    },
    prompt_above_buttons: true,
    button_choices: ['Continue'],
    post_trial_gap: 350,
    button_html: () => {
        const t = (0, taskStore_1.taskStore)().translations;
        return `<button class="primary">${t.continueButtonText}</button>`;
    },
    keyboard_choices: 'NO_KEYS',
    trial_ends_after_audio: false,
    response_allowed_while_playing: false,
    on_load: () => {
        const prompt = (0, taskStore_1.taskStore)().heavyInstructions ? 'mentalRotationInstruct3DDownex' : 'mentalRotationInstruct3D';
        helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio[prompt]);
        const pageStateHandler = new helpers_1.PageStateHandler(prompt, true);
        (0, helpers_1.setupReplayAudio)(pageStateHandler);
        (0, helpers_1.addExperimenterButtons)();
        (0, helpers_1.setupFullscreenButton)();
    },
    on_finish: () => {
        helpers_1.PageAudioHandler.stopAndDisconnectNode();
        taskSetup_1.jsPsych.data.addDataToLastTrial({
            audioButtonPresses: helpers_1.PageAudioHandler.replayPresses,
        });
    },
};
exports.polygonInstructions = {
    type: plugin_html_multi_response_1.default,
    data: () => {
        return {
            assessment_stage: 'instructions',
        };
    },
    stimulus: () => {
        const t = (0, taskStore_1.taskStore)().translations;
        const prompt = t.mentalRotationInstructPolygonDownex;
        return `
      <div class="lev-stimulus-container">
        ${(0, helpers_1.getParticipantUtilityButtonsHtml)(replayButtonHtmlId)}
        <div class="lev-row-container instruction">
          <p>${prompt}</p>
        </div>
      </div>
    `;
    },
    prompt_above_buttons: true,
    button_choices: ['Continue'],
    post_trial_gap: 350,
    button_html: () => {
        const t = (0, taskStore_1.taskStore)().translations;
        return `<button class="primary">${t.continueButtonText}</button>`;
    },
    keyboard_choices: 'NO_KEYS',
    trial_ends_after_audio: false,
    response_allowed_while_playing: false,
    on_load: () => {
        const prompt = 'mentalRotationInstructPolygonDownex';
        helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio[prompt]);
        const pageStateHandler = new helpers_1.PageStateHandler(prompt, true);
        (0, helpers_1.setupReplayAudio)(pageStateHandler);
        (0, helpers_1.addExperimenterButtons)();
        (0, helpers_1.setupFullscreenButton)();
    },
    on_finish: () => {
        helpers_1.PageAudioHandler.stopAndDisconnectNode();
        taskSetup_1.jsPsych.data.addDataToLastTrial({
            audioButtonPresses: helpers_1.PageAudioHandler.replayPresses,
        });
    },
};
